export function ApprovalsFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/approvals-filled.svg'"></ng-include>`
    }
}